import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';
import { reactive, watch, ref } from 'vue';
import useDecryptSymbols from './useDecryptSymbols';

const { decryptSymbols } = useDecryptSymbols();

const companies = reactive([]);
const refetchCompanies = ref(null);

const GET_COMPANIES = gql`
  query CompaniesQuery {
    companies {
      NAME
      COMPANYID
    }
  }
`;

const useCompaniesQuery = function () {
  const { result, loading, error, refetch } = useQuery(GET_COMPANIES);
  refetchCompanies.value = refetch;
  watch(result, () => {
    const decrypted = decryptSymbols(result.value.companies);
    companies.splice(0, companies.length, ...decrypted);
  });
};

export default {
  useCompaniesQuery,
  companies,
  refetchCompanies,
};
